import styled from 'styled-components';
import {
  COUNT_PIXEL_DESCRIPTION_SEARCH_IN_DESKTOP,
  COUNT_PIXEL_DESCRIPTION_SEARCH_IN_MOBILE,
} from 'config';
import { HeaderSizes, MainIndents, Media } from 'enums';
import { Text } from 'view/atoms';
import { PADDING_DIFF_FOR_SCROLL, CSS_FOR_SCROLL } from 'styles/customScroll';

export const SearchList = styled.div`
  padding-right: calc(
    ${MainIndents.mobile.paddingRight} - ${PADDING_DIFF_FOR_SCROLL}px
  );
  padding-left: ${MainIndents.mobile.paddingLeft};
  padding-top: ${MainIndents.mobile.paddingTop};

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & > :first-child {
    margin-bottom: 20px;
    height: 20px;
  }

  @media ${Media.tablet} {
    padding-right: calc(
      ${MainIndents.tablet.paddingRight} - ${PADDING_DIFF_FOR_SCROLL}px
    );
    padding-left: ${MainIndents.tablet.paddingLeft};
    padding-top: ${MainIndents.tablet.paddingTop};
  }

  @media ${Media.notebook} {
    padding: 0;
    min-height: 62px;

    & > :first-child {
      margin-bottom: 0;
      height: fit-content;
    }
  }
`;

export const TextTitle = styled(Text)`
  margin-bottom: 20px;
  height: 20px;

  @media ${Media.notebook} {
    margin-bottom: 14px;
    line-height: 128%;
    margin-bottom: 0;
  }
`;

export const TextDescription = styled(TextTitle)`
  line-height: 130%;

  @media ${Media.notebook} {
    height: fit-content;
  }
`;

export const SearchListContent = styled.div`
  overflow-y: auto;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-right: ${PADDING_DIFF_FOR_SCROLL}px;
  max-height: calc(
    100vh - ${COUNT_PIXEL_DESCRIPTION_SEARCH_IN_MOBILE}px -
      ${HeaderSizes.mobile.height}
  );

  @media ${Media.tablet} {
    max-height: calc(
      100vh - ${COUNT_PIXEL_DESCRIPTION_SEARCH_IN_MOBILE}px -
        ${HeaderSizes.tablet.height}
    );
  }

  @media ${Media.notebook} {
    padding-bottom: 20px;
    max-height: calc(
      100vh - ${COUNT_PIXEL_DESCRIPTION_SEARCH_IN_DESKTOP}px -
        ${HeaderSizes.notebook.height}
    );

    & > :first-child {
      margin-bottom: 0;
      height: fit-content;
    }
  }

  ${CSS_FOR_SCROLL}
`;
